module.exports = __webpack_public_path__ + "static/media/bfile-calc.48a8dfd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-calc.svg
// module id = 1017
// module chunks = 0